/**
 * The other figure for a price a comparison page sets as "$365 a year" or "$175 a month", so a
 * visitor does not divide or multiply in their head. A price in any other wording, a range or one
 * with a currency this cannot read gets null, never a guess.
 */
const WHOLE = String.raw`\$(\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?`;

const YEARLY = new RegExp(`^${WHOLE} a year(?![\\w])`);

const MONTHLY = new RegExp(`^${WHOLE} a month(?![\\w])`);

function dollars(digits: string): number {
  return Number(digits.replaceAll(",", ""));
}

/** "About $30 a month, billed yearly" for "$365 a year, paid once a year". */
export function monthlyFromYearly(price: string): string | null {
  const found = YEARLY.exec(price);

  return found?.[1] === undefined
    ? null
    : `About $${Math.round(dollars(found[1]) / 12).toLocaleString("en-US")} a month, billed yearly`;
}

/** "About $2,100 a year, billed monthly" for "$175 a month". */
export function yearlyFromMonthly(price: string): string | null {
  const found = MONTHLY.exec(price);

  return found?.[1] === undefined
    ? null
    : `About $${(dollars(found[1]) * 12).toLocaleString("en-US")} a year, billed monthly`;
}
